import { combineReducers } from 'redux';

import data from './data';
import favourites from 'Favourites/store/reducers';

const emptyReducer = (s = {}) => s;

/**
 * This will be needed post-split to prevent redux automatically removing substates for which there is no reducer
 */
const readOnlyReducers = {
    favourites: emptyReducer,
};

const reducers = combineReducers({
    ...readOnlyReducers,
    data,
    favourites,
});

export default reducers;
